module.exports = __webpack_public_path__ + "static/media/address.a7ab26f6.svg";